import { SharedService } from '../../service/shared.service';
import { TeamService } from '../../service/team.service';
import { ProjectService } from '../../service/project.service';
import { UserService } from '../../service/user.service';
import {
  APP_SHELL_MOBILE_MAX_WIDTH,
  SidebarStateService,
} from '../../service/sidebar-state.service';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { SharedModule, team } from '../../shared/shared.module';
import { RouterLink, RouterOutlet, ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { NgScrollbar } from 'ngx-scrollbar';
import { CommonModule } from '@angular/common';
import { ProgressComponent } from '@coreui/angular';
import {
  ContainerComponent,
  ColorModeService,
  ShadowOnScrollDirective,
  SidebarComponent,
  ModalModule,
  CardModule,
  GridModule,
  ButtonModule
} from '@coreui/angular';
import { TeamFooterComponent, TeamHeaderComponent } from '.';
import { IconDirective } from '@coreui/icons-angular';
// 引入需要的 Icons，包含 cilChatBubble
import {
  cilMenu, cilPlus, cilApps, cilTerminal, cilZoom, cilLightbulb, cilChartLine, cilChatBubble, cilPuzzle,
  cilPencil, cilTrash, cilOptions, cilPin, cilStar, cilUser
} from '@coreui/icons';
import { ImaginusService } from '../../service/imaginus.service';
import { TeamImaginusNavService } from '../../service/team-imaginus-nav.service';
import { FavoriteAppsService, FavoriteAppLink } from '../../service/favorite-apps.service';
import { UserPreferencesService } from '../../service/user-preferences.service';
import { ChatroomUnreadService } from '../../service/chatroom-unread.service';
import {
  ChatConversation,
  ChatConversationService,
} from '../../service/chat-conversation.service';
import { ImaginusSessionSearchComponent } from '../imaginus-session-search/imaginus-session-search.component';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TokenStorageService } from '@services/token-storage.service';

interface AppChild {
  name: string;
  url: string;
  icon?: string;
}

interface AppItem {
  id: number;
  name: string;
  description: string;
  url: string;
  icon: string;
  children?: AppChild[];
  roles?: string[];
  alwaysVisible?: boolean;
  desktopOnly?: boolean;
}

@Component({
  selector: 'team-layout',
  templateUrl: './team-layout.component.html',
  styleUrls: ['./team-layout.component.scss'],
  standalone: true,
  imports: [
    SidebarComponent,
    RouterLink,
    NgScrollbar,
    TeamHeaderComponent,
    ShadowOnScrollDirective,
    ContainerComponent,
    RouterOutlet,
    TeamFooterComponent,
    CommonModule,
    ProgressComponent,
    SharedModule,
    IconDirective,
    ModalModule,
    CardModule,
    GridModule,
    ButtonModule,
    ImaginusSessionSearchComponent,
    TranslateModule,
  ]
})
export class TeamLayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('sidebar1') private sidebarRef?: SidebarComponent;

  public isMobile = window.innerWidth <= APP_SHELL_MOBILE_MAX_WIDTH;
  public sidebarVisible = !this.isMobile;
  public sidebarUnfoldable = false;
  public appModalVisible = false;
  readonly isDesktopShell: boolean;

  public userRoles: string[] = [];
  team: team = {
    team_code: '',
    team_name: '',
    accounts: [],
    activated_applications: []
  };
  team_code: string = '';

  readonly #colorModeService = inject(ColorModeService);
  readonly colorMode = this.#colorModeService.colorMode;

  icons = { cilMenu, cilPlus, cilApps, cilTerminal, cilZoom, cilLightbulb, cilChartLine, cilChatBubble, cilPuzzle, cilPencil, cilTrash, cilOptions, cilPin, cilStar, cilUser };

  favoriteApps: FavoriteAppLink[] = [];
  personalAvatarUrl = '';
  teamAvatarUrls: Record<string, string> = {};
  private favoriteAppsSub?: Subscription;
  private personalAvatarSub?: Subscription;

  /** 側欄旁 Kebab／觸控選單；快取於欄位，避免 getters + matchMedia 在 dev CD 輪詢不一致觸發 NG0100 */
  showSessionMenuDropdown = true;
  /** 對應長按動作底表 */
  useSessionTouchSheet = false;

  /** 側欄顯示用（釘選排序由 TeamImaginusNavService 計算） */
  imaginusList: { id: string; name: string }[] = [];
  /** 勿用 strategy: 'fixed' + 有 transform 的側欄：選單座標會飄到離按鈕很遠；用 absolute。勿在 toggle 上用 preventDefault，否則展不開。 */
  sessionMenuPopperOptions: Record<string, unknown> = {
    placement: 'right-start',
    strategy: 'absolute',
  };
  private sessionLpt: ReturnType<typeof setTimeout> | null = null;
  private suppressNextSessionLink = false;
  sessionActionSheetOpen = false;
  sessionActionTarget: { id: string; name: string } | null = null;
  private imaginusNavSub?: Subscription;
  private imaginusTitleSub?: Subscription;
  private imaginusRouteSub?: Subscription;
  private sidebarToggleRequestSub?: Subscription;
  private chatroomUnreadSub?: Subscription;
  private chatConversationsSub?: Subscription;

  /** 聊天模式：左側「對話紀錄」改顯示聊天室清單（場域聊天室 + 私訊） */
  chatConversations: ChatConversation[] = [];

  imaginusSessionTitle: string | null = null;

  private allApps: AppItem[] = [
    {
      id: 1,
      name: '能源管理專案',
      description: '場域監控、設備管理與數據分析中心',
      url: '/team/:team_code/application/1',
      icon: 'cilLightbulb',
      roles: ['member'],
      children: [
        { name: '尋找專案', url: '/team/:team_code/application/1/find' },
        { name: '我的場域', url: '/team/:team_code/application/1/places' },
        { name: '服務管理', url: '/team/:team_code/application/1/management' }
      ]
    },
    {
      id: 2,
      name: '能源管理服務',
      description: '進階報告生成與能源顧問服務',
      url: '/team/:team_code/application/2',
      icon: 'cilChartLine',
      roles: ['member'],
      children: [
        { name: '尋找服務商', url: '/team/:team_code/application/2/find' },
        { name: '我的場域', url: '/team/:team_code/application/2/places' },
        { name: '績效總覽', url: '/team/:team_code/application/2/management' }
      ]
    },
    {
      id: 4,
      name: '能源工程專案',
      description: '場域施工、設備安裝與工程管理平台',
      url: '/team/:team_code/application/4',
      icon: 'cilPuzzle',
      roles: ['member'],
      children: [
        { name: '尋找專案', url: '/team/:team_code/application/4/find' },
        { name: '我的專案', url: '/team/:team_code/application/4/project' },
        { name: '技術支援', url: '/team/:team_code/application/4/support' }
      ]
    }
  ];

  public appList: AppItem[] = [];
  private teamDataFetchSeq = 0;

  /** 僅在 team 資料與目前路由 team_code 一致時顯示，避免切換團隊時短暫顯示舊應用 */
  get modalAppList(): AppItem[] {
    if (!this.team_code || this.team?.team_code !== this.team_code) {
      return [];
    }
    return this.appList;
  }

  get teamAppsLoading(): boolean {
    return !!this.team_code && this.team?.team_code !== this.team_code;
  }

  constructor(
    private userService: UserService,
    private ProjectService: ProjectService,
    private route: ActivatedRoute,
    private router: Router,
    private TeamService: TeamService,
    private sharedService: SharedService,
    public sidebarState: SidebarStateService,
    private imaginusService: ImaginusService,
    public teamImaginusNav: TeamImaginusNavService,
    public favoriteAppsService: FavoriteAppsService,
    private userPreferencesService: UserPreferencesService,
    private readonly cdr: ChangeDetectorRef,
    private chatroomUnread: ChatroomUnreadService,
    public chatConversationService: ChatConversationService
  ) {
    const qsDesktop =
      typeof window !== 'undefined' &&
      new URLSearchParams(window.location.search).get('desktop_shell') === '1';
    if (qsDesktop && typeof localStorage !== 'undefined') {
      localStorage.setItem('ima_desktop_shell', '1');
    }
    const cachedDesktop =
      typeof localStorage !== 'undefined' &&
      localStorage.getItem('ima_desktop_shell') === '1';
    this.isDesktopShell =
      qsDesktop ||
      cachedDesktop ||
      (typeof navigator !== 'undefined' &&
        navigator.userAgent.toLowerCase().includes('imaonedesktopshell'));
    this.updateSessionUiHints();
  }

  ngOnInit(): void {
    this.checkMobile();
    this.favoriteApps = this.favoriteAppsService.getSnapshot();
    this.personalAvatarUrl =
      this.userService.profile_picture || this.userService.defaultAvatarUrl;
    this.personalAvatarSub = this.userService.currentProfilePicture.subscribe((url) => {
      this.personalAvatarUrl = url || this.defaultScopeAvatar;
    });
    this.userService.loadPersonalAvatarUrl().subscribe();
    this.refreshFavoriteScopeAvatars();
    this.sidebarToggleRequestSub = this.sidebarState
      .onSidebarToggleRequest$('team')
      .subscribe(() => this.toggleSidebar());
  }

  private updateSessionUiHints(): void {
    this.useSessionTouchSheet =
      this.isMobile ||
      (typeof matchMedia !== 'undefined' && matchMedia('(hover: none)').matches);
    this.showSessionMenuDropdown = !this.useSessionTouchSheet;
  }

  ngAfterViewInit() {
    this.route.params.subscribe(params => {
        const code = params['team_code'] || this.sharedService.getRouteId('team_code');
        if (code && code !== this.team_code) {
           this.team_code = code;
           this.appList = [];
           this.loadTeamData();
        } else if (code && this.appList.length === 0) {
           this.team_code = code;
           this.loadTeamData();
        } else {
           this.recomputeImaginusList();
        }
    });
    this.checkMobile();
    this.syncDesktopSidebar(true);
    this.sidebarState.queueShellSidebarOffsetSync(this.isMobile);
    this.sidebarState.observeShellSidebarOffset(() => this.isMobile);
    this.imaginusNavSub = this.teamImaginusNav.sessions$.subscribe(() => {
      this.recomputeImaginusList();
    });
    this.imaginusTitleSub = this.teamImaginusNav.activeSessionTitle$.subscribe((t) => {
      this.imaginusSessionTitle = t;
    });
    this.imaginusRouteSub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        this.recomputeImaginusList();
        if (this.isMobile) {
          this.sidebarVisible = false;
          this.sidebarState.setSidebarState('team', false);
          this.cdr.markForCheck();
        } else {
          this.syncDesktopSidebar(true);
        }
      });
    this.favoriteAppsSub = this.favoriteAppsService.links$.subscribe((links) => {
      this.favoriteApps = links;
      this.refreshFavoriteScopeAvatars();
    });
    this.chatroomUnreadSub = this.chatroomUnread.unreadPlaces$.subscribe(() => {
      this.cdr.markForCheck();
    });
    this.chatConversationsSub = this.chatConversationService.conversations$.subscribe(
      (list) => {
        this.chatConversations = list;
        this.cdr.markForCheck();
      }
    );
    this.userService.get_self_info().subscribe({
      next: (data) => {
        if (data?.user?.email) {
          this.chatConversationService.setCurrentEmail(data.user.email);
        }
      },
      error: () => {},
    });
  }

  ngOnDestroy(): void {
    this.sidebarState.disconnectShellSidebarOffsetObserver();
    this.clearSessionLongPressTimer();
    this.imaginusNavSub?.unsubscribe();
    this.imaginusTitleSub?.unsubscribe();
    this.imaginusRouteSub?.unsubscribe();
    this.favoriteAppsSub?.unsubscribe();
    this.personalAvatarSub?.unsubscribe();
    this.sidebarToggleRequestSub?.unsubscribe();
    this.chatroomUnreadSub?.unsubscribe();
    this.chatConversationsSub?.unsubscribe();
  }

  /** 是否在統一聊天收件匣（左側 nav 切換為聊天室清單） */
  get isChatMode(): boolean {
    const path = this.router.url.split('?')[0].split('#')[0];
    return path.startsWith(`/team/${this.team_code}/chats`);
  }

  get activeChatConversationKey(): string {
    const path = this.router.url.split('?')[0].split('#')[0];
    const prefix = `/team/${this.team_code}/chats/`;
    return path.startsWith(prefix) ? decodeURIComponent(path.slice(prefix.length)) : '';
  }

  isChatConversationActive(conv: ChatConversation): boolean {
    return conv?.conversation_key === this.activeChatConversationKey;
  }

  isChatConversationUnread(conv: ChatConversation): boolean {
    return this.chatConversationService.isUnread(conv);
  }

  trackByConversationKey = (_: number, conv: ChatConversation) =>
    conv?.conversation_key ?? _;

  get defaultScopeAvatar(): string {
    return this.userService.defaultAvatarUrl;
  }

  recomputeImaginusList(): void {
    const s = this.teamImaginusNav.getSessionsSnapshot();
    this.imaginusList = this.team_code
      ? this.teamImaginusNav.getOrderedSessions(this.team_code, s)
      : [];
  }

  get displayImaginusList(): { id: string; name: string }[] {
    return this.imaginusList;
  }

  get sidebarToggleAriaLabel(): string {
    if (this.isMobile) {
      return this.sidebarVisible ? '關閉選單' : '開啟選單';
    }
    return this.sidebarUnfoldable ? '展開側欄' : '收合側欄';
  }

  isSessionQueryActive(sessionId: string): boolean {
    const qp = this.router.parseUrl(this.router.url).queryParams;
    if ((qp['session'] || '') !== sessionId) {
      return false;
    }
    return (qp['scope'] as string) === 'team' && (qp['team_code'] || '') === this.team_code;
  }

  isNewDialogActive(): boolean {
    const path = this.router.url.split('?')[0];
    if (path !== '/home' && path !== '/imaginus') {
      return false;
    }
    const qp = this.router.parseUrl(this.router.url).queryParams;
    if (qp['session']) {
      return false;
    }
    return (qp['scope'] as string) !== 'team' || (qp['team_code'] || '') === this.team_code;
  }

  onSessionMenuPin(s: { id: string; name: string }, ev: Event): void {
    ev.stopPropagation();
    this.teamImaginusNav.togglePin(this.team_code, s.id);
    this.recomputeImaginusList();
  }

  onSessionMenuRename(s: { id: string; name: string }, ev: Event): void {
    ev.stopPropagation();
    if (!this.team_code) {
      return;
    }
    this.teamImaginusNav.requestRenameSession(
      { id: s.id, name: s.name, scope: 'team', team_code: this.team_code },
      this.router
    );
  }

  onSessionMenuDelete(s: { id: string; name: string }, ev: Event): void {
    ev.stopPropagation();
    if (!this.team_code) {
      return;
    }
    this.teamImaginusNav.requestDeleteSession(
      { id: s.id, name: s.name, scope: 'team', team_code: this.team_code },
      this.router
    );
  }

  sessionLabel(name: string): string {
    const n = (name || '對話').trim() || '對話';
    return n.length > 32 ? `${n.slice(0, 32)}…` : n;
  }

  favoriteScopeLabel(fav: FavoriteAppLink): string | null {
    if (fav.section === 'team') {
      if (fav.team_name) {
        return fav.team_name;
      }
      if (fav.team_code && fav.team_code === this.team?.team_code && this.team?.team_name) {
        return this.team.team_name;
      }
      return fav.team_code || '團隊';
    }
    return '個人';
  }

  favoriteLinkTitle(fav: FavoriteAppLink): string {
    const scope = this.favoriteScopeLabel(fav);
    return scope ? `${fav.label}（${scope}）` : fav.label;
  }

  favoriteScopeAvatarUrl(fav: FavoriteAppLink): string {
    if (fav.section === 'team' && fav.team_code) {
      return this.teamAvatarUrls[fav.team_code] || this.defaultScopeAvatar;
    }
    return (
      this.personalAvatarUrl ||
      this.userService.profile_picture ||
      this.defaultScopeAvatar
    );
  }

  onFavoriteScopeAvatarError(event: Event, fav: FavoriteAppLink): void {
    const img = event.target as HTMLImageElement | null;
    if (!img || img.dataset['avatarFallback'] === '1') {
      return;
    }
    img.dataset['avatarFallback'] = '1';
    img.src = this.defaultScopeAvatar;
    if (fav.section === 'team' && fav.team_code) {
      this.teamAvatarUrls = { ...this.teamAvatarUrls, [fav.team_code]: this.defaultScopeAvatar };
      return;
    }
    this.userService.loadPersonalAvatarUrl(true).subscribe({
      next: (url) => {
        this.personalAvatarUrl = url || this.defaultScopeAvatar;
        if (img.isConnected) {
          img.dataset['avatarFallback'] = '0';
          img.src = this.personalAvatarUrl;
        }
      },
    });
  }

  private refreshFavoriteScopeAvatars(): void {
    const hasPersonalFavorite = this.favoriteApps.some((f) => f.section !== 'team');
    if (hasPersonalFavorite) {
      const cached = this.userService.profile_picture;
      if (cached) {
        this.personalAvatarUrl = cached;
      } else {
        this.userService.loadPersonalAvatarUrl().subscribe();
      }
    }

    const codes = new Set(
      this.favoriteApps
        .filter((f) => f.section === 'team' && f.team_code)
        .map((f) => String(f.team_code)),
    );
    codes.forEach((code) => {
      if (this.teamAvatarUrls[code]) {
        return;
      }
      this.TeamService.loadTeamAvatarUrl(code).subscribe({
        next: (url) => {
          this.teamAvatarUrls = { ...this.teamAvatarUrls, [code]: url || this.defaultScopeAvatar };
        },
        error: () => {
          this.teamAvatarUrls = { ...this.teamAvatarUrls, [code]: this.defaultScopeAvatar };
        },
      });
    });
  }

  resolveAppUrl(url: string): string {
    return (url || '').replace(/:team_code/g, this.team_code);
  }

  isFavoriteUrl(url: string): boolean {
    return this.favoriteAppsService.isFavorite(this.resolveAppUrl(url));
  }

  onToggleFavoriteClick(ev: Event, child: AppChild, appIcon?: string): void {
    ev.preventDefault();
    ev.stopPropagation();
    this.toggleFavoriteApp(child, appIcon);
  }

  toggleFavoriteApp(child: AppChild, appIcon?: string): void {
    const url = this.resolveAppUrl(child.url);
    this.favoriteAppsService.toggle({
      label: child.name,
      url,
      icon: appIcon || 'cilApps',
      section: 'team',
      team_code: this.team_code,
      team_name: this.team.team_name,
    });
  }

  isFavoriteLinkActive(link: FavoriteAppLink): boolean {
    // 只高亮「最長前綴匹配」的常用連結，確保同一時間至多只有一個（最精確的）亮起。
    // 例如進入場域內頁 .../places/{id}（或其子頁）時，只亮「場域內容」，
    // 不會因前綴相同而把「我的場域」.../places 也一起標記為使用中。
    const currentPath = this.router.url.split('?')[0].split('#')[0];
    const linkPath = (link.url || '').split('?')[0].split('#')[0];
    if (!linkPath || !this.isPathPrefixMatch(currentPath, linkPath)) {
      return false;
    }
    const bestLen = this.favoriteApps.reduce((max, fav) => {
      const favPath = (fav.url || '').split('?')[0].split('#')[0];
      return favPath && this.isPathPrefixMatch(currentPath, favPath)
        ? Math.max(max, favPath.length)
        : max;
    }, 0);
    return linkPath.length === bestLen;
  }

  /** 以「路徑分段」為界判斷 linkPath 是否為 currentPath 的前綴（或完全相同）。 */
  private isPathPrefixMatch(currentPath: string, linkPath: string): boolean {
    return currentPath === linkPath || currentPath.startsWith(`${linkPath}/`);
  }

  navigateFavoriteLink(link: FavoriteAppLink): void {
    if (this.isMobile) {
      this.sidebarVisible = false;
      this.sidebarState.setSidebarState('team', false);
    }
    this.router.navigateByUrl(link.url);
  }

  /** 點側欄常用項目右側星星按鈕（或縮合模式右鍵）→ 取消釘選 */
  onUnpinFavoriteClick(ev: Event, fav: FavoriteAppLink): void {
    ev.preventDefault();
    ev.stopPropagation();
    if (!fav?.id) return;
    const confirmed = window.confirm(`要將「${fav.label}」從側欄常用移除嗎？`);
    if (!confirmed) return;
    this.favoriteAppsService.remove(fav.id);
  }

  onSessionLinkClick(ev: Event, _s: { id: string; name: string }): void {
    if (this.suppressNextSessionLink) {
      this.suppressNextSessionLink = false;
      ev.preventDefault();
      ev.stopPropagation();
    }
  }

  onSessionRowTouchStart(s: { id: string; name: string }, e: TouchEvent): void {
    if (!this.useSessionTouchSheet) {
      return;
    }
    if (e.touches && e.touches.length > 1) {
      return;
    }
    this.clearSessionLongPressTimer();
    this.sessionLpt = setTimeout(() => {
      this.sessionLpt = null;
      this.suppressNextSessionLink = true;
      this.sessionActionTarget = s;
      this.sessionActionSheetOpen = true;
    }, 480);
  }

  onSessionRowTouchEnd(_e: Event): void {
    this.clearSessionLongPressTimer();
  }

  onSessionRowTouchMove(_e: TouchEvent): void {
    this.clearSessionLongPressTimer();
  }

  private clearSessionLongPressTimer(): void {
    if (this.sessionLpt) {
      clearTimeout(this.sessionLpt);
      this.sessionLpt = null;
    }
  }

  onSessionActionSheetVisible(visible: boolean): void {
    if (visible === this.sessionActionSheetOpen) {
      return;
    }
    setTimeout(() => {
      this.sessionActionSheetOpen = visible;
      if (!visible) {
        this.sessionActionTarget = null;
      }
      this.cdr.markForCheck();
    }, 0);
  }

  closeSessionActionSheet(): void {
    this.sessionActionSheetOpen = false;
    this.sessionActionTarget = null;
  }

  onSessionActionSheetPin(t: { id: string; name: string }): void {
    this.onSessionMenuPin(t, new Event('click'));
    this.closeSessionActionSheet();
  }

  onSessionActionSheetRename(t: { id: string; name: string }): void {
    this.onSessionMenuRename(t, new Event('click'));
    this.closeSessionActionSheet();
  }

  onSessionActionSheetDelete(t: { id: string; name: string }): void {
    this.onSessionMenuDelete(t, new Event('click'));
    this.closeSessionActionSheet();
  }

  private refreshImaginusNavFromApi(): void {
    if (!this.team_code) {
      this.teamImaginusNav.clear();
      return;
    }
    this.imaginusService.get_team_sessions(this.team_code).subscribe({
      next: (data) => {
        const list = (data?.sessions || []).map((s: { id: string; name?: string }) => ({
          id: s.id,
          name: s.name || '對話',
        }));
        const t = this.router.parseUrl(this.router.url);
        const sid = (t.queryParams['session'] as string) || '';
        if (sid && !list.some((r: { id: string }) => r.id === sid)) {
          const snap = this.teamImaginusNav.getSessionsSnapshot().find((s) => s.id === sid);
          if (snap) {
            list.unshift(snap);
          }
        }
        this.teamImaginusNav.setSessions(list);
      },
      error: () => this.teamImaginusNav.clear(),
    });
  }

  loadTeamData() {
    const code = this.team_code;
    const seq = ++this.teamDataFetchSeq;
    this.TeamService.get_team_info(code).subscribe(
      (data) => {
        if (seq !== this.teamDataFetchSeq || code !== this.team_code) {
          return;
        }
        TokenStorageService.refreshToken(data.token);
        this.team = data.data;
        this.userPreferencesService.setSelectedTeamCode(this.team_code);
        this.filterApps();
        this.refreshImaginusNavFromApi();
        this.TeamService.get_user_team_roles(this.team_code).subscribe(
          (data) => {
            this.userRoles = data.roles;
            TokenStorageService.refreshToken(data.token);
          },
          (error) => { this.userRoles = []; }
        );
        this.cdr.markForCheck();
      },
      (error) => {
        const code = error?.error?.code;
        if (error?.status === 403 && code === 'team_disabled') {
          alert('此團隊已被平台停用，無法使用。如有疑問請聯繫平台管理員。');
          this.router.navigate(['/home']);
          return;
        }
        if (error?.status === 403 && (error?.error?.message || '').includes('disabled')) {
          alert('此團隊已被平台停用，無法使用。如有疑問請聯繫平台管理員。');
          this.router.navigate(['/home']);
          return;
        }
        this.router.navigate(['/404']);
      }
    );
  }

  filterApps() {
    if (!this.team || !this.team.activated_applications) {
      this.appList = [];
      return;
    }
    this.appList = this.allApps.filter(app =>
      this.team.activated_applications!.some(activated => activated.appId === app.id)
    );
    // 場域聊天室未讀：追蹤有啟用且含場域的 app（1：能源管理專案、2：能源管理服務）
    if (this.team_code) {
      [1, 2].forEach((appId) => {
        if (this.team.activated_applications!.some((a) => a.appId === appId)) {
          this.chatroomUnread.register(this.team_code, appId);
        }
      });
    }
  }

  get hasChatroomUnread(): boolean {
    return this.chatroomUnread.hasAnyUnread;
  }

  isPlacesLink(url: string): boolean {
    return /\/places$/.test((url || '').split('?')[0]);
  }

  isRoleAllowed(item: any): boolean {
    if (!item.roles) return true;
    return item.roles.some((role: string) => this.userRoles.includes(role));
  }

  @HostListener('window:resize')
  onResize(): void {
    this.checkMobile();
  }

  private checkMobile(): void {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth <= APP_SHELL_MOBILE_MAX_WIDTH;
    if (this.isMobile !== wasMobile) {
      this.sidebarUnfoldable = false;
      this.sidebarVisible = !this.isMobile;
      this.sidebarState.setSidebarState('team', this.sidebarVisible);
      if (!this.isMobile) {
        this.syncDesktopSidebar(true);
      }
      this.cdr.markForCheck();
    } else if (!this.isMobile) {
      this.syncDesktopSidebar(true);
    }
    this.sidebarState.queueShellSidebarOffsetSync(this.isMobile);
    this.updateSessionUiHints();
  }

  private syncDesktopSidebar(force = false): void {
    if (this.isMobile) {
      return;
    }
    if (force || !this.sidebarVisible) {
      this.sidebarVisible = true;
      this.sidebarState.setSidebarState('team', true);
    }
    this.sidebarState.repairDesktopSidebarShell(this.sidebarRef, {
      narrow: this.sidebarUnfoldable,
      visible: true,
    });
    this.sidebarState.queueShellSidebarOffsetSync(this.isMobile);
    this.cdr.markForCheck();
  }

  toggleSidebar(): void {
    if (this.isMobile) {
      this.sidebarVisible = !this.sidebarVisible;
      this.sidebarState.setSidebarState('team', this.sidebarVisible);
    } else {
      this.sidebarUnfoldable = !this.sidebarUnfoldable;
      this.syncDesktopSidebar(true);
      this.sidebarState.queueShellSidebarOffsetSync(this.isMobile);
    }
  }

  // 自定義遮罩點擊處理
  hideSidebar(): void {
    if (this.isMobile) {
      this.sidebarVisible = false;
      this.sidebarState.setSidebarState('team', false);
    }
  }

  onVisibleChange(event: boolean): void {
    if (!this.isMobile) {
      if (!event || !this.sidebarVisible) {
        this.syncDesktopSidebar(true);
      }
      return;
    }
    if (event === this.sidebarVisible) {
      return;
    }
    setTimeout(() => {
      this.sidebarVisible = event;
      this.sidebarState.setSidebarState('team', event);
      this.cdr.markForCheck();
      this.sidebarState.queueShellSidebarOffsetSync(this.isMobile);
    }, 0);
  }

  onAppModalVisibleChange(visible: boolean): void {
    if (visible === this.appModalVisible) {
      return;
    }
    setTimeout(() => {
      this.appModalVisible = visible;
      this.cdr.markForCheck();
    }, 0);
  }

  openAppModal() {
    if (this.team_code && this.team?.team_code !== this.team_code) {
      this.appList = [];
      this.loadTeamData();
    } else {
      this.filterApps();
    }
    this.appModalVisible = true;
  }

  navigateToLink(url: string) {
    this.appModalVisible = false;
    if (this.isMobile) {
      this.sidebarVisible = false;
      this.sidebarState.setSidebarState('team', false);
    }
    this.router.navigateByUrl(this.resolveAppUrl(url));
  }

  get imaHomeQueryParams(): { new?: string } {
    let path = this.router.url.split('?')[0];
    if (path.includes('#')) {
      path = path.split('#').pop() || path;
    }
    if (!path.startsWith('/')) {
      path = `/${path}`;
    }
    const teamHome = this.team_code ? `/team/${this.team_code}/home` : '';
    if (path === '/home' || path === '/imaginus' || (teamHome && path === teamHome)) {
      return { new: '1' };
    }
    return {};
  }
}
